import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Mental} from "../Mental";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {TweenLite} from "gsap";

export class MentalFeatureIndicatorView extends PIXI.Container implements StageLayer {
    private static xSplitActive: PIXI.Sprite;
    private static xSplitBlink: PIXI.Sprite;
    private static xSplitBlast: TimelineSprite;
    private static xSplitActivated: boolean = false;
    private static xNudgeActive: PIXI.Sprite;
    private static xNudgeBlink: PIXI.Sprite;
    private static xNudgeBlast: TimelineSprite;
    private static xNudgeActivated: boolean = false;
    private static xWaysActive: PIXI.Sprite;
    private static xWaysBlink: PIXI.Sprite;
    private static xWaysBlast: TimelineSprite;
    private static xWaysActivated: boolean = false;
    private static fadeDuration: number = 0.1;

    public static createItems(): void {
        const layer: StageLayer = NolimitApplication.getLayerByName(Mental.LAYERS.FEATURE_INDICATOR)!,
            symWidth: number = 144;

        layer.position.y = 90;

        this.xSplitActive = this.createSprite("xSplitActive");
        this.xSplitActive.scale.set(0.7);
        this.xSplitActive.position.set((symWidth * 3) + this.xSplitActive.width * 0.5, this.xSplitActive.height * 0.95);
        this.xSplitBlink = this.createSprite("xSplitBlink");
        this.xSplitBlink.scale.set(0.7);
        this.xSplitBlink.position = this.xSplitActive.position;

        this.xNudgeActive = this.createSprite("xNudgeActive");
        this.xNudgeActive.scale.set(0.7);
        this.xNudgeActive.position.set((symWidth * 3) + this.xNudgeActive.width * 1.3, this.xNudgeActive.height * 0.95);
        this.xNudgeBlink = this.createSprite("xNudgeBlink");
        this.xNudgeBlink.scale.set(0.7);
        this.xNudgeBlink.position = this.xNudgeActive.position;

        this.xWaysActive = this.createSprite("xWaysActive");
        this.xWaysActive.scale.set(0.65);
        this.xWaysActive.position.set((symWidth * 3) + this.xWaysActive.width + 5, this.xWaysActive.height * 0.3);
        this.xWaysBlink = this.createSprite("xWaysBlink");
        this.xWaysBlink.scale.set(0.65);
        this.xWaysBlink.position = this.xWaysActive.position;

        this.xSplitBlast = this.createBlastTimelineSprite();
        this.xSplitBlast.position = this.xSplitActive.position;

        this.xNudgeBlast = this.createBlastTimelineSprite();
        this.xNudgeBlast.position = this.xNudgeActive.position;

        this.xWaysBlast = this.createBlastTimelineSprite();
        this.xWaysBlast.position = this.xWaysActive.position;

        layer.addChild(this.xSplitActive, this.xNudgeActive, this.xWaysActive, this.xSplitBlink, this.xNudgeBlink, this.xWaysBlink, this.xSplitBlast, this.xNudgeBlast, this.xWaysBlast);
    }

    public static resetAll(): void {
        this.hideXSplitActiveIndicator();
        this.xSplitBlink.visible = false;
        this.xSplitBlast.hide();
        this.xSplitActivated = false;
        this.hideXNudgeActiveIndicator();
        this.xNudgeBlink.visible = false;
        this.xNudgeBlast.hide();
        this.xNudgeActivated = false;
        this.hideXWaysActiveIndicator();
        this.xWaysBlink.visible = false;
        this.xWaysBlast.hide();
        this.xWaysActivated = false;
    }

    public static playXSplitActiveIndicator(): void {
        if (this.xSplitActivated) {
            this.xSplitBlink.visible = true;
            this.xSplitBlink.alpha = 0;
            TweenLite.to(this.xSplitBlink, {
                duration: this.fadeDuration,
                alpha: 1
            });
            TweenLite.to(this.xSplitBlink, {
                duration: this.fadeDuration,
                alpha: 0,
                delay: this.fadeDuration,
                onComplete: () => {this.xSplitBlink.visible = false}
            });
        } else {
            this.xSplitActive.visible = true;
            this.xSplitActive.alpha = 0;
            TweenLite.to(this.xSplitActive, {
                duration: this.fadeDuration,
                alpha: 1
            });

            this.xSplitBlast.getAnimationAutoShowHide(true, true);

            this.xSplitActivated = true;
        }
    }

    public static playXNudgeActiveIndicator(): void {
        if (this.xNudgeActivated) {
            this.xNudgeBlink.visible = true;
            this.xNudgeBlink.alpha = 0;
            TweenLite.to(this.xNudgeBlink, {
                duration: this.fadeDuration,
                alpha: 1
            });
            TweenLite.to(this.xNudgeBlink, {
                duration: this.fadeDuration,
                alpha: 0,
                delay: this.fadeDuration,
                onComplete: () => {this.xNudgeBlink.visible = false}
            });
        } else {
            this.xNudgeActive.visible = true;
            this.xNudgeActive.alpha = 0;
            TweenLite.to(this.xNudgeActive, {
                duration: this.fadeDuration,
                alpha: 1
            });

            this.xNudgeBlast.getAnimationAutoShowHide(true, true);

            this.xNudgeActivated = true;
        }
    }

    public static playXWaysActiveIndicator(): void {
        if (this.xWaysActivated) {
            this.xWaysBlink.visible = true;
            this.xWaysBlink.alpha = 0;
            TweenLite.to(this.xWaysBlink, {
                duration: this.fadeDuration,
                alpha: 1
            });
            TweenLite.to(this.xWaysBlink, {
                duration: this.fadeDuration,
                alpha: 0,
                delay: this.fadeDuration,
                onComplete: () => {this.xWaysBlink.visible = false}
            });
        } else {
            this.xWaysActive.visible = true;
            this.xWaysActive.alpha = 0;
            TweenLite.to(this.xWaysActive, {
                duration: this.fadeDuration,
                alpha: 1
            });

            this.xWaysBlast.getAnimationAutoShowHide(true, true);

            this.xWaysActivated = true;
        }
    }

    private static hideXSplitActiveIndicator(): void {
        TweenLite.to(this.xSplitActive, {
            duration: this.fadeDuration,
            alpha: 0,
            onComplete: () => {this.xSplitActive.visible = false}
        });
    }

    private static hideXNudgeActiveIndicator(): void {
        TweenLite.to(this.xNudgeActive, {
            duration: this.fadeDuration,
            alpha: 0,
            onComplete: () => {this.xNudgeActive.visible = false}
        });
    }

    private static hideXWaysActiveIndicator(): void {
        TweenLite.to(this.xWaysActive, {
            duration: this.fadeDuration,
            alpha: 0,
            onComplete: () => {this.xWaysActive.visible = false}
        });
    }

    private static createSprite(name: string): PIXI.Sprite {
        const item: PIXI.Sprite = new PIXI.Sprite(Mental.assetLoader.getTextures(name)[0]);
        item.visible = false;
        item.anchor.set(0.5);

        return item;
    }

    private static createBlastTimelineSprite(): TimelineSprite {
        const item: TimelineSprite = new TimelineSprite(Mental.assetLoader.getTextures("multBlast"));
        item.hide();
        item.anchor.set(0.5);
        item.scale.set(1.35);
        item.blendMode = PIXI.BLEND_MODES.ADD;

        return item;
    }
}